import { useEffect, useState } from "react";
import { apiClient } from "../../lib/api-client";

interface Author {
  id: string;
  name: string;
  slug: string;
  bio: string | null;
}

export function AuthorsPage() {
  const [authors, setAuthors] = useState<Author[]>([]);

  useEffect(() => {
    apiClient.get<{ items: Author[] }>("/public/authors").then((data) => setAuthors(data.items));
  }, []);

  return (
    <div>
      <h1>Autores</h1>
      <ul style={{ listStyle: "none", padding: 0, display: "grid", gap: "var(--space-3)" }}>
        {authors.map((author) => (
          <li key={author.id} className="card">
            <strong>{author.name}</strong>
            {author.bio && <p className="text-muted" style={{ marginTop: "var(--space-2)", marginBottom: 0 }}>{author.bio}</p>}
          </li>
        ))}
      </ul>
    </div>
  );
}
